export default __webpack_public_path__ + "static/london-mobile-fd83a359cd36a5b7e83ccd7a4932277a.png";